import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar,
    IonList,
    IonRadioGroup,
    IonLabel,
    IonItem,
    IonRadio,
    IonIcon
  } from '@ionic/react';
  import React from 'react';
  import { RouteComponentProps } from 'react-router-dom';
  import './SelectModule.css';
  import { gridOutline, gridSharp, gitBranchOutline, gitBranchSharp, documentTextOutline, documentTextSharp,
    removeOutline, removeSharp, albumsOutline, albumsSharp, bandageOutline, businessOutline, businessSharp, createOutline, createSharp,
    locationOutline, locationSharp, idCardOutline, idCardSharp
  } from 'ionicons/icons';
  import { ServerService } from '../../../services/Server';
  import { useHistory, useParams } from 'react-router';
  import Util from '../../../services/Util';
  
  export interface ModuleChoices {
    id: string;
    iosIcon: string;
    mdIcon: string;
    title: string;
    tab: string;
    pageId: number;
    orderNo: number;
  }
  
  export const modules: ModuleChoices[] = [
    {
      id:"0",
      title: ' ',
      iosIcon: removeOutline,
      mdIcon: removeSharp,
      tab:"",
      pageId:0,
      orderNo:0
    },{
      id:"1",
      title: 'My Tasks',
      iosIcon: documentTextOutline,
      mdIcon: documentTextSharp,
      tab:'mytasks',
      pageId:1,
      orderNo:1
    },{
      id:"2",
      title: 'Workflows',
      iosIcon: gitBranchOutline,
      mdIcon: gitBranchSharp,
      tab: 'workflows',
      pageId:3,
      orderNo:2
    },{
      id:"3",
      title: 'More',
      iosIcon: gridOutline,
      mdIcon: gridSharp,
      tab: 'more',
      pageId:6,
      orderNo:7
    },{
      id:"4",
      title: 'B1-DAR',
      iosIcon: albumsOutline,
      mdIcon: albumsSharp,
      tab: 'dar',
      pageId:7,
      orderNo:3
    },{
      id:"5",
      title: 'B1-IA',
      iosIcon: bandageOutline,
      mdIcon: bandageOutline,
      tab: 'ia',
      pageId:9,
      orderNo:4
    },{
      id:"6",
      title: 'BCON',
      iosIcon: businessOutline,
      mdIcon: businessSharp,
      tab: 'con',
      pageId:11,
      orderNo:5
    },{
      id:"7",
      title: 'Work Permit',
      iosIcon: createOutline,
      mdIcon: createSharp,
      tab: 'wp',
      pageId:13,
      orderNo:6
    },{
      id:"8",
      title: 'Timesheet',
      iosIcon: locationOutline,
      mdIcon: locationSharp,
      tab: 'bams',
      pageId:21,
      orderNo:7
    },{
      id:"9",
      title: 'Permit',
      iosIcon: idCardOutline,
      mdIcon: idCardSharp,
      tab: 'site',
      pageId:26,
      orderNo:8
    }
  ];

  interface SelectModulePageProps extends RouteComponentProps<{
    id : string;
  }> {}

  type SelectModuleParams = {
    pageIdx:string,
    bid:any
  }

  const SelectModule: React.FC<SelectModulePageProps> = ({match}) => {
  
    const name:string = "Select Module";

    const history = useHistory();

    const server = new ServerService();
    const moduleEnable = server.moduleEnable;
    const {pageIdx, bid} = useParams<SelectModuleParams>();
    const util = new Util();

    const sortedModules = [...modules]

    sortedModules.sort((a,b) => a.orderNo - b.orderNo)

    // useEffect(() => {
    //   console.log("SelectModule : useEffect")

    // }, [])
    
    return (
      <IonPage>
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
              <IonMenuButton />
            </IonButtons>
            <IonTitle>{name}</IonTitle>
          </IonToolbar>
        </IonHeader>
  
        <IonContent>
          <IonHeader collapse="condense">
            <IonToolbar>
              <IonTitle>{name}</IonTitle>
            </IonToolbar>
          </IonHeader>
          
          <IonList>
  
            <IonRadioGroup value={match.params.id}>

              {sortedModules.map((module, index) => {
                  if (moduleEnable[parseInt(module.id)]) {
                    //console.log("moduleEnable:"+module.title+":"+moduleEnable[parseInt(module.id)])
                    return (
                      <IonItem key={index}>
                      <IonIcon ios={module.iosIcon} md={module.mdIcon} />
                      <IonLabel>&nbsp;{module.title}</IonLabel>
                      <IonRadio value={module.id} onClick={(e:any) => {
                        const selectedId = parseInt(e.target.value)
                        console.log("selectedId:"+selectedId);
                        /*
                          clear old button
                        */
                        var id;
                        Object.keys(server.moduleCfg)?.forEach((key:any) => {
                            if (selectedId!==3
                                || (selectedId === 3 && key === pageIdx)
                              ) {
                              const page = util.getKeyValue(key)(server.moduleCfg)
                              for(id in page) {
                                if (page[id] === selectedId) {
                                  page[id] = 0;
                                  break;
                                }
                              }
                            }
                        })

                        /*
                          set button module
                        */
                        server.tabPageIdx = "0"
                        server.nextTab = ""
                        server.saveTabPageIdx()

                        server.moduleCfg[pageIdx][bid] = selectedId

                        server.saveModuleLocal()
                        
                        history.goBack()
                    }}/>
                      </IonItem>
                    );
                  } else {
                    return null;
                  }
              })}

            </IonRadioGroup>
          </IonList>
  
        </IonContent>
      </IonPage>
    );
  };
  
  export default SelectModule;
  